import {
  CheckCircleIcon,
  ClockIcon,
  WalletIcon
} from '@heroicons/react/24/solid'

import { InvoiceStatus } from '@/api/models/finance'

type Props = {
  unpaid: boolean
  status: string
}

const InvoiceButtonText = ({ unpaid, status }: Props) => {
  if (unpaid && status === InvoiceStatus.isProcessing) {
    return (
      <>
        <ClockIcon className="h-16 w-16 text-grey-100" /> В обработке
      </>
    )
  }

  if (unpaid && status === InvoiceStatus.NotProcessing) {
    return (
      <>
        <WalletIcon className="h-16 w-16 text-white" />
        Оплатить
      </>
    )
  }
  if (!unpaid) {
    return (
      <>
        <CheckCircleIcon className="h-16 w-16 text-grey-100" />
        Оплачено
      </>
    )
  }
}

export default InvoiceButtonText
